namespace('compass.hotel');

compass.requireLib('compass.util.format');
compass.requireLib('compass.util.parse');

compass.hotel.BookingGridWidget = compass.defineWidget(function BookingGridWidget(options) {

	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	var forceReserveButtonEnabled = _settings.forceReserveButtonEnabled; /* if there is housing reserved already, the reserve button should always be enabled */

	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;
	var weekdayFormat = compass.util.dateFormatter("dddd");
	var shortWeekdayFormat = compass.util.dateFormatter("ddd");
	var monthDateFormat = compass.util.dateFormatter("mmmm dd");
	var fullMonthFormat = compass.util.dateFormatter("mmmm");
	var fullMonthYearFormat = compass.util.dateFormatter("mmmm yyyy");
	var shortMonthFormat = compass.util.dateFormatter("mmm");
	var isoFormat = compass.util.dateFormatter('yyyy-mm-dd');
	var fullDateFormat = compass.util.dateFormatter('dddd, mmmm d, yyyy. ');

	var _minNights;
	var _selectedNightData = [ ];
	var _nightBuilders = [ ];
	var _nightsInstructionId;

    var _drawRate = _settings.drawRate == null ? true : _settings.drawRate;
	_settings.jsDates = _.map(_settings.dates, function (date) {
		return compass.util.parse.ISODateParser(date.date);
	});
	_settings.jsDatesWithAvailCount = _.map(_settings.dates, function (date) {
		return {'jsDate':compass.util.parse.ISODateParser(date.date), 'availCount':date.availCount};
	});

    var _GINOn = _settings.GINOn;
    var _GINThreshold = _settings.GINThreshold;


	var _maxAllowed = _settings.maxAllowed;
	var groupMax1 = 'You can reserve ';
	var groupMax2 = (_GINOn ? 'Groups of ' + _GINThreshold + ' or more rooms require a group sub-block contract.' : '');

    if ( _settings.setData == null ){ _settings.setData = true;}

	this.grabValues = function() {
		var selectedNights = me.find('.selected.night');
		var chosenNights = _.map(selectedNights, function(n) {
			var d = $j(n).data('nightData');
			return {
				nightDate : d.date,
				fulldate : $j(n).data('date'),
				date : d.date,
				roomPrice : d.roomPrice,
				inclusiveRoomPrice : (d.inclusiveRoomPrice || d.roomPrice),
				numRooms : $j(n).find('input').val()
			};
		});

		var stays = [ ];
		var partials = [ ];
		var count = 0;
		if (chosenNights.length > 0) {
			_.each(chosenNights, function(n){
				n.numRooms = parseInt(n.numRooms, 10);
				if (n.numRooms > count) {
					_.times(n.numRooms - count, function(){
						partials.push({
							arrive: n.date
						});
					});
				} else if (n.numRooms < count) {
						_.times(count - n.numRooms, function(){
							var stay = partials.pop();
							stay.depart = n.date;
							stay.rooms = 1;
							stays.push(stay);
						});
					}
				count = n.numRooms;
			});

			var departNight = selectedNights.last().next().data('nightData');
			_.each(partials, function(stay){
				stay.depart = departNight.date;
				stay.rooms = 1;
				stays.push(stay);
			});
			chosenNights.push({
				nightDate: departNight.date,
				fulldate: selectedNights.last().next().data('date'),
				date: departNight.date,
				inclusiveRoomPrice: (departNight.inclusiveRoomPrice || departNight.roomPrice),
				roomPrice: departNight.roomPrice,
				numRooms: 0
			});
		}

		return {
			stays : stays,
			nights : chosenNights
		};
	};

	this.getBasicData = function() {
		var selectedNights = me.find('.selected.night');

		var arrive = selectedNights.first().data('date');
		if(selectedNights.length == 1) { //if they only select one night we have to assume they are leaving the next day.  So we add one to the arrive date (which is a pain in javascript)
			var date = new Date(arrive);
			date.setDate(date.getDate() + 1);
			var depart = new Date(date.toDateString());
		}else{
			var depart = selectedNights.last().next().data('date');
		}
		var rooms = selectedNights.first().find('input').val();

		return {
			arrive : isoFormat(arrive),
			depart : isoFormat(depart),
			rooms : Number(rooms)
		};
	};

	this.setupControls = function() {
		me.find('.night.unselected.blocked').attr('tabindex', 0);
		if(_settings.stay.showStay) {
			var arrive = _getNight(_settings.stay.arrive);
			var depart = _getNight(_settings.stay.depart);

			if(arrive && depart) {
				_selectNight(arrive);
				_selectNight(depart);
				me.find('.night.unselected.blocked+.night.unblocked').attr('tabindex', 0);
			}
		}

		me.refreshReservationButton();
	};

	_setData = function(data) {
		_minNights = Number(_settings.minNights);
		_.each(_.zip(data.dates, _nightBuilders), function(args) {
			var night = args[0];
			var nightBuilder = args[1];
			nightBuilder(night);
		});
		if(me.hasSelection()) {
			var first = _firstSelected();
			if(first.hasClass('unblocked')) {
				first = first.nextAll(':not(.unblocked)').first();
			}
			var last = _lastSelected();
			if(last.hasClass('unblocked')) {
				last = last.prevAll(':not(.unblocked)').last().next();
			}
			_makeSelected(_nightRange(first, last));
		}
	};

	this.render = function(widgetElem) {
		_nightBuilders = [ ];
		_nightsInstructionId = compass.generateId();
		var nightsContainer = _drawNights(_settings.jsDatesWithAvailCount);
		var mobileScrollMessage = _d.div({className:'scrollMessage'},
			_d.i({ className : 'fa-regular fa-arrow-left-long'}),
			' Scroll left or right for more dates ',
			_d.i({ className : 'fa-regular fa-arrow-right-long'})
		);
		nightsContainer.ready(function() {
			if (nightsContainer[0].scrollWidth <= nightsContainer[0].clientWidth) {
				mobileScrollMessage.hide();
			}
		});
		widgetElem.append(
			_drawHeader(_settings.jsDates),
			nightsContainer,
			mobileScrollMessage
		);

		_setData(_settings);
		me.setupControls();
	};

	this.hasSelection = function() {
		return me.find('.selected.night').length > 0;
	};

	this.clearSelection = function() {
		me.find('.night').removeClass('selected').removeClass('closable').addClass('unselected');
		me.find('.nights').removeClass('marked').addClass('unmarked');
		me.find('.night input').val(1);
		me.find('.gridInstructions').text('No dates selected');
	};

	this.forceEnableReserveButton = function(){
		forceReserveButtonEnabled = true;
	};

	var _drawNights = function(nightsData) {
		var markedClass = (_settings.checkInDate && _settings.checkOutDate) ? 'marked ' : 'unmarked ';
		var nightsClasses = markedClass + (_settings.allowComplexStays ? 'nights' : 'nights uneditable');
		var nights = _d.div({ className : nightsClasses },
			_.map(nightsData, _drawNight)
		);

		return nights;
	};

	var _drawNight = function(nightData) {
		var isSelected =_settings.checkInDate <= isoFormat(nightData.jsDate) && isoFormat(nightData.jsDate) < _settings.checkOutDate;
		var nightClasses = 'night ' + (isSelected ? 'selected ' : 'unselected ')  + shortWeekdayFormat(nightData.jsDate);
		var maxAllowed = Math.min(nightData.availCount, _maxAllowed);
		var inputValue = Math.min(_settings.requestedRooms, maxAllowed);
		var nightId = compass.generateId();
		var nightInput = _d.input({ type : 'text', value : inputValue, pattern : '[0-9]*', autocomplete: 'off', id: nightId });
		nightInput.bind('keydown', _handleInputValidation);
		nightInput.bind('keyup', _handleInput);
		nightInput.bind('change', _handleInputChange);
		nightInput.bind('focus', function(e) {
			var input = $j(e.target);
			setTimeout(function() { input.select(); }, 1);
		});

		var _drawRoomsLabel = function(allowComplexStays) {
			if(allowComplexStays) {
				var roomLabelAttrs = {
					className : 'roomsLabel secondaryText',
					'aria-label' : '1 room'
				};
				return _d.div(roomLabelAttrs, "Rooms:");
			}
		};

		var night = _d.div({ className : nightClasses, role : 'button' },
			_d.div({ className : 'header' },
				_d.div({ className : 'arrive' }, 'Check', _d.span({ 'aria-hidden' : true }, '-'), 'in'),
				_d.div({ className : 'depart' }, 'Check', _d.span({ 'aria-hidden' : true }, '-'), 'out'),
				_d.div({
					className : 'nightCloseButton fa-regular fa-xmark',
					role : 'button',
					'ARIA-role' : 'button',
					'ARIA-label' : 'Remove Date',
					tabindex : 0
				}).activate(_handleUnselectNight),
				_d.div({ className : 'date', 'aria-hidden' : true },
					_d.div({ className : 'dateMonth' }, shortMonthFormat(nightData.jsDate)),
					_d.div({ className : 'dateDay' }, nightData.jsDate.getDate()),
					_d.div({ className : 'dateEnd' })
				),
				_d.div({ className : 'marker' })
			),
			_d.div({ className : 'controls', 'aria-hidden' : true },
				_drawRoomsLabel(_settings.allowComplexStays),
				_d.div({ className : 'editNight' },
					_d.label({ 'for' : nightId}, nightInput)),
				_d.div({ className : 'price notranslate' }, '')
			)
		).activate(_nightClickHandler);
		night.data('date', nightData.jsDate);

		_nightBuilders.push(function(nightData) {
			_updateNightClasses(night, nightData);
			night.data('nightData', nightData);
		});

		night.hover(function () {
			if (night.hasClass('unblocked') && night.prev().hasClass('unblocked')) {
				return;
			}
			if (night.siblings('.selected').length) {
				if (night.prevAll('.selected').length) {
					if (night.prevUntil('.selected').hasClass('unblocked')) {
						return;
					}
				} else if (night.nextUntil('.selected').hasClass('unblocked')) {
					return;
				}
				me.find('.nights').addClass('hover');
			}
		}, function () {
			me.find('.nights').removeClass('hover');
		});

		return night;
	};

	var _updateNightClasses = function(night, nightData) {
		var priceLabel = night.find('.price');
		var unblocked = nightData.availInfo == 'UNBLOCKED';
		var soldOut = nightData.availInfo == 'OUT' ||
				nightData.availInfo == 'CLOSED' ||
				nightData.availInfo == 'CUT-OFF' ||
				Number(nightData.availCount) <= 0;

		night.removeClass('blocked unblocked event');
		if(unblocked) {
			night.addClass('unblocked');
			priceLabel.text('');
		} else if(soldOut) {
			night.addClass('unblocked soldout');
			priceLabel.text('Sold out');
		} else {
			night.addClass('blocked');
			if(_drawRate) {
				priceLabel.text(_cf((nightData.inclusiveRoomPrice || nightData.roomPrice)));
			}
		}
		night.attr('aria-disabled', soldOut || unblocked);

		if(nightData.eventDate != 'OUT') {
			night.addClass('event');
		}

		night.attr('title', fullDateFormat(compass.util.parse.ISODateParser(nightData.date)) + ' ' + priceLabel.text());
	};

	this._getHeaderDate = function(nights) {
		var start = nights[0];
		var end = nights[nights.length - 1];

		if(start.getFullYear() == end.getFullYear()) {
			if(start.getMonth() == end.getMonth()) {
				return fullMonthYearFormat(start);
			} else {
				return fullMonthFormat(start) + ' - ' + fullMonthYearFormat(end);
			}
		} else {
			return fullMonthYearFormat(start) + '/' + fullMonthYearFormat(end);
		}
	};

	me.refreshReservationButton = function (){
		if (me.hasSelection()) {
			me.trigger('BookingGridWidget.hasNights');
		} else {
			me.trigger('BookingGridWidget.gridEmpty');
		}
	};

	var _drawHeader = function(nights) {
		var headerDate = me._getHeaderDate(nights);
		var week = _.first(nights, 7);

		var _drawHeaderGroupMax = function(allowComplexStays) {
			if (allowComplexStays) {
				return  _d.div({ className : 'headerGroupMax'},
						_settings.hideNumberOfRoomsAvailable !== true ? (_d.div(groupMax1 + _getMaxAvail() + ' more ' + (_getMaxAvail() > 1 ? 'rooms' : 'room') + ' at this hotel.')) : '&nbsp;'
				);
			}
		};

		return _d.div({ className : 'gridHeader' },
			_d.div({ className : 'headerWrapper'},
				_d.div({ className : 'headerYear' }, headerDate),
				_drawHeaderGroupMax(_settings.allowComplexStays)
			),
			_d.reader(
				_d.span({ className : 'gridInstructions', 'aria-live' : 'assertive' },
					'No dates selected'
				)
			),
			_d.div({ className : 'headerBorder'}),
			_d.div({ className : 'headerWeekdays' },
				_.map(week, function(night) {
					var classes = 'headerWeekday ' + shortWeekdayFormat(night);
					return _d.div({ className : classes }, weekdayFormat(night).substring(0, 1));
				})
			)
		);
	};

	function _isSelectable(night) {
		return !(night.hasClass('soldOut') || night.hasClass('unblocked'));
	}

  function _getTargetNight(e) {
    var ele = $j(e.target);
    return ele.is('night') ? ele : ele.closest('.night');
  }

	function _updateGridInstructions() {
		var hasSelection = me.hasSelection();
		if(hasSelection) {
			var checkIn = _firstSelected().data('nightData');
			var checkOut = _lastSelected().next().data('nightData');
			if (!checkOut) {
				// if last card in booking grid was picked there is no checkout, so default to one day after checkin
				var checkInDate = moment(checkIn.date, 'YYYY-MM-DD');
				var checkOutDate = checkInDate.clone().add(1, 'day').format('YYYY-MM-DD');
				checkOut = {
					date: checkOutDate
				};
			}
			var msg = 'Dates selected: Check in ' + fullDateFormat(compass.util.parse.ISODateParser(checkIn.date)) +
				' Check out ' + fullDateFormat(compass.util.parse.ISODateParser(checkOut.date));
			me.find('.gridInstructions').text(msg);
		} else {
			me.find('.gridInstructions').text('No dates selected');
		}
	}

  function _nightClickHandler(e) {
		var night = _getTargetNight(e);
    _selectNight(night);
		me.refreshReservationButton();
		_updateGridInstructions();
		me.trigger('BookingGridWidget.selectionChanged', { hasSelection : me.hasSelection() });
  }

	function _selectNight(selectedNight) {
		var currentSelection = me.find('.selected.night');
		var currentFirst = currentSelection.first();
		var currentLast = currentSelection.last();
		var isMarked = me.find('.nights').is('.marked');
		var newSelection;

		if(!selectedNight.hasClass('selected')) {
			var hasUnblocked = function(n) { return $j(n).hasClass('unblocked'); };
			if(currentSelection.length > 0) {
				if(currentLast.index() < selectedNight.index()) {
					// Adding on to end
					var newRange = currentLast.nextUntil(selectedNight);
					if(_.any(newRange, hasUnblocked)) {
					 	if(_isSelectable(selectedNight)) {
							newSelection = selectedNight;
							me.find('.nights').removeClass('marked').addClass('unmarked');
						}
					} else if(_isSelectable(selectedNight.prev())) {
						newSelection = currentSelection.add(newRange);
						me.find('.nights').addClass('marked').removeClass('unmarked');
					}
				} else if(currentFirst.index() > selectedNight.index()) {
					// Adding on to begining
					if(_isSelectable(selectedNight)) {
						if(isMarked || currentSelection.length > 1){
							var newRange = selectedNight.add(selectedNight.nextUntil(currentFirst));
							if(_.any(newRange, hasUnblocked)) {
								newSelection = selectedNight;
								me.find('.nights').removeClass('marked').addClass('unmarked');
							} else {
								newSelection = currentSelection.add(newRange);
							}
						} else {
							newSelection = selectedNight;
						}
					}
				} else {
					newSelection = currentSelection;
				}
			} else if(_isSelectable(selectedNight)) {
				newSelection = selectedNight;
			}

			if(newSelection) {
				_makeSelected(newSelection);
			}
		}
	}

	function _makeSelected(nights) {
		var currSelection = me.find('.selected.night');
		me.find('.night').removeClass('selected').addClass('unselected').attr('tabindex', -1);
		if(nights.length === 0) {
			me.find('.nights').removeClass('marked').addClass('unmarked');
		} else {
			nights.addClass('selected').removeClass('unselected');
		}

		// Bug 17824 need each to remember the maximum availability it can provide instead of fooling the user into 
		// thinking they can book rooms that are not available on a particular night
		// var first = currSelection.first();
		// var firstVal = first.find('input').val();
		// for(var next = first.prev(); next.hasClass('selected'); next = next.prev()) {
		// 	next.find('input').val(firstVal);
		// }
		// var last = currSelection.last();
		// var lastVal = last.find('input').val();
		// for(var next = last.next(); next.hasClass('selected'); next = next.next()) {
		// 	next.find('input').val(lastVal);
		// }

		me.find('.night.unselected.blocked').attr('tabindex', 0);
		me.find('.night.unselected.blocked+.night.unblocked').attr('tabindex', 0);
	}

	function _handleUnselectNight(e) {
		e.stopPropagation();
		var night = $j(e.target).closest('.night');
		_unselectNight(night);
		_updateGridInstructions();
		me.refreshReservationButton();
		me.trigger('BookingGridWidget.selectionChanged', { hasSelection : me.hasSelection() });
	}

	function _unselectNight(night) {
		if(night.hasClass('selected')) {
			night.removeClass('selected').addClass('unselected');
		} else {
			var nights = me.find('.selected.night');
			if(nights.length > 1) {
				night.prev().removeClass('selected').addClass('unselected');
			} else {
				me.find('.nights').removeClass('marked').addClass('unmarked');
			}
		}

		var currentSelection = me.find('.selected.night');
		_makeSelected(currentSelection);
	}

	function unselectNights(night){
		if(!night.prev().hasClass('selected') || !night.next().hasClass('selected')) {
			_unselectNight(night);
		} else {
			var init = _nightRange(_firstSelected(), night);
			var tail = _nightRange(night, _lastSelected());
			var shorter = init.length < tail.length ? init : tail;
			_unselectNight(shorter);
		}
	}

	function _handleInputValidation(e) {
		var k = e.keyCode;
		// Non-numeric exceptions: backspace, delete, tab, escape, enter
		if(k == 46 || k == 8 || k == 9 || k == 27 || k == 13 ||
				// ctrl+a, home, end, left, right
				(k == 65 && e.ctrlKey) || (k >= 35 && k <= 39)) {
			return;
		// Prevent any non-numeric or shifted-numeric input
		} else if(e.shiftKey || (k < 48 || k > 57) && (k < 96 || k > 105)) {
			e.preventDefault();
		}
	}

	function reportMaxReached(maxAllowed) {
		_d.alert('You have exceeded the maximum number of rooms on this night.');
	}

	function _handleInput(e) {
		var input = $j(e.target);
		var enteredVal = input.val();
		var night = input.closest('.night');
		var nightData = night.data('nightData');

		if(enteredVal == "0") {
			unselectNights(night);
		} else {
			var nights = me.find('.selected.night');
			var currVal = nights.not(night).first().find('input').val();
			var allNightsHaveSameValue = _.all(nights.not(night).find('input'), function(i) { return $j(i).val() == currVal; });
			if((!night.prev().hasClass('selected') && allNightsHaveSameValue) || _settings.syncNumberOfNights) {
				if (enteredVal !== "") {
					_propagateInputValue(nights, enteredVal);
				}

				var ginThresholdReached = checkGINThreshold(night);

				if (ginThresholdReached){
				}
			} else {
				var maxInfo = checkGroupMax(night);
				if (maxInfo.reachedMax) {
					input.val(maxInfo.maxAllowed);
					reportMaxReached(maxInfo.maxAllowed, nightData);
				}
			}
		}
	}

	function _propagateInputValue(nights, value) {
		if ( _settings.syncNumberOfNights) {
			var currVal = nights.first().find('input').val();
			nights.find('input').val(currVal);
		} else {
			var currVal = nights.first().find('input').val();
			nights.each(function () {
				$(this).find('input').val(value);
				var maxInfo = checkGroupMax($(this));
				if (maxInfo.reachedMax) {
					$(this).find('input').val(maxInfo.maxAllowed);
				}
			});
		}
		var firstError = _.find(nights, function(input) {
			return $(input).find('input').val() != value;
		});
		if (firstError){
			var maxInfo = checkGroupMax($(firstError));
			$(firstError).find('input').focus();
			reportMaxReached(maxInfo.maxAllowed);
		}
	}

	this.updateAvailability = function(stays) {
		var nights = _.map(me.find('.night'), function(el) { return $j(el).data('nightData'); });

		_.each(stays, function(stay) {
			var stayNights = _.filter(nights, function(n) {
				return n.date >= stay.arrive && n.date < stay.depart;
			});

			_.each(stayNights, function(night) {
				night.availCount = Math.max(0, Number(night.availCount) - stay.rooms);
			});
		});

		if(_settings.meetingInfo.groupsEnabled && _settings.allowComplexStays && _settings.hideNumberOfRoomsAvailable !== true) {
			var rooms = _.foldl(_.pluck(stays, 'rooms'), function(acc, n) { return acc + n; }, 0);
			_maxAllowed = Math.max(0, _maxAllowed - rooms);
			$j('.headerGroupMax').empty().append(_d.div(groupMax1 + _getMaxAvail() + ' more ' + (_getMaxAvail() > 1 ? 'rooms' : 'room') + ' at this hotel.'), _d.div(groupMax2));
		}

		_.map(me.find('.night'), function(el) {
			var night = $j(el);
			var nightData = night.data('nightData');
			_updateNightClasses(night, nightData);
		});
	};

	function _handleInputChange(e){
		var night = _getTargetNight(e);
		var nightData = night.data('nightData');
		var input = night.find('input');
		var enteredVal = input.val();
		var maxInfo = checkGroupMax(night);

		if(enteredVal === "") {
			/* we only want to unselect nights if the value is empty onchange because it gets annoying if nights are unselected when you backspace everything in a night input */
			unselectNights(night);
		} else {
			// cap the value if they crossed the threshold of the max number of reservations allowed
			if(maxInfo.reachedMax){
				input.val(maxInfo.maxAllowed);
				reportMaxReached(maxInfo.maxAllowed, nightData);
			}
		}
	}

	function checkGroupMax(night){
		var input = night.find('input');
		var nightData = night.data('nightData') || {availCount : 10000};
		var inputVal = parseInt(input.val());
		var maxAvail = Math.min(nightData.availCount, _maxAllowed);
		return {
			reachedMax: inputVal > maxAvail,
			maxAllowed: maxAvail
		};
	}

    function checkGINThreshold(night){
        var input = night.find('input');
        var nightData = night.data('nightData') || {availCount : 10000};
        var inputVal = parseInt(input.val());
        return _GINOn && inputVal >= _GINThreshold;
    }


	function _getNight(date) {
		return $j(_.find(me.find('.night:not(.unblocked+.unblocked)'), function(n) {
			var d = $j(n).data('nightData');
			if (d.fulldate) {
				return d.fulldate == date;
			} else {
				return d.date == date;
			}
		}));
	}

	function _firstSelected() {
		return me.find('.night.selected:first');
	}

	function _lastSelected() {
		return me.find('.night.selected:last');
	}

	function _nightRange(start, end) {
		if(start.get(0) === end.get(0)) { return start; }
		else { return me.find(start).nextUntil(end).andSelf().add(end); }
	}

	function _getMaxAvail() {
		return Math.min(_.max(_.pluck(_settings.dates, 'availCount')), _maxAllowed);
	}

	var _d = jQuery.dom;
}, {
	WUID : 'defaultBookingGridWidget',
	widgetName : 'BookingGridWidget',
	dates : [ ],
	checkInDate : undefined,
	checkOutDate : undefined,
	stay : { showStay : false },
	allowComplexStays : true,
	hideNumberOfRoomsAvailable : false,
	syncNumberOfNights : false,
	forceReserveButtonEnabled : false,
	drawRate : true,
	setData : true,
	maxAllowed : 99999,
	requestedRooms : 1
});
